import React from 'react';
import classnames from 'classnames';
import Icon from 'utils/components/icon';
import { HTMLDivElement } from 'utils/global';
import { User } from '../../../state/types';

const SIZES_IN_PX = {
  small: 24,
  normal: 34,
  medium: 44,
  large: 54,
  'extra-large': 64
};

interface UserAvatarProps extends React.AllHTMLAttributes<HTMLDivElement> {
  user: User;
  avatarSize: 'small' | 'normal' | 'medium' | 'large' | 'extra-large';
  className?: string;
  onClick?: (e?: React.MouseEvent) => any;
}

const UserAvatar: React.FC<UserAvatarProps & React.AllHTMLAttributes<HTMLDivElement>> = ({
  user,
  className,
  avatarSize = 'normal',
  onClick = () => {},
  ...attributes
}) => {
  if (!user) {
    return null;
  }

  const isGuestAvatar = user.isGuestAvatar();
  let icon = null;
  let thumbnailUrl = null;

  const avatarClassName = classnames(
    'user-image',
    className,
    {
      'extra-large-user-image': avatarSize === 'extra-large',
      'large-user-image': avatarSize === 'large',
      'medium-user-image': avatarSize === 'medium',
      'normal-user-image': avatarSize === 'normal',
      'small-user-image': avatarSize === 'small',
      online: user.get('isOnline')
    },
    isGuestAvatar && `avatar-${user.getGuestColor()}`,
    {
      ['avatar-default']: user.isDefaultImage()
    }
  );

  const avatarStyle: React.CSSProperties = {};

  if (isGuestAvatar) {
    icon = <Icon name={user.getGuestIcon()} />;
  } else {
    thumbnailUrl = user.getThumbnailUrl({
      width: SIZES_IN_PX[avatarSize],
      height: SIZES_IN_PX[avatarSize]
    });
    avatarStyle.backgroundImage = `url(${thumbnailUrl})`;
  }

  return (
    <div className={avatarClassName} style={avatarStyle} {...attributes} onClick={onClick}>
      {icon}
    </div>
  );
};

export default UserAvatar;
